export interface RollMaterial {
	Id: number | null;
	Name: string;
	Active: boolean;
}

export const ROLL_MATERIAL_INITIAL_VALUES: RollMaterial = {
	Id: null,
	Name: "",
	Active: true,
};
